module.exports = __webpack_public_path__ + "img/icon_tab_smart_s.313756d5.png";